import { GameDayModel } from '../../models/gameday-model';
import { amountFormat } from '../gameday.constants';

interface ViewOrder {
  id: number;
  orderNumber: number;
  manager: string;
  account: string;
  series: string;
  maturityDate: Date;
  maturity: string;
  amount: number;
  amountFormatted: string;
  priority: string;
  orderType: string;
  comments: string;
  coupon?: number;
  linkType: string;
  categoryColor?: string;
}

const ACCOUNT_TYPE = 'account';
const NON_ACCOUNT_TYPE = 'non-account';

function capitalize(s: string): string {
  return typeof s === 'string' ? s.charAt(0).toUpperCase() + s.slice(1) : '';
}

const maturityFormat = 'MM/DD/YY';

function getManagerName(order: GameDayModel.Order): string {
  const syndicateDepartment = order?.syndicateDepartment as {
    name?: string;
    shortName?: string;
    departmentName?: string;
    manager?: {
      name?: string;
      shortName?: string;
      departmentName?: string;
    };
  };
  const manager = (order as unknown as {
    manager?:
      | string
      | {
          name?: string;
          shortName?: string;
          departmentName?: string;
        };
  }).manager;
  const managerName =
    typeof manager === 'string'
      ? manager
      : manager?.name || manager?.shortName || manager?.departmentName;
  const nestedManager = syndicateDepartment?.manager;

  return (
    syndicateDepartment?.name ||
    syndicateDepartment?.shortName ||
    syndicateDepartment?.departmentName ||
    managerName ||
    nestedManager?.name ||
    nestedManager?.shortName ||
    nestedManager?.departmentName ||
    ''
  );
}

function getViewOrder(order: GameDayModel.Order): ViewOrder {
  const priority: string =
    order.priority === GameDayModel.OrderPriority.retail && order.category.name
      ? order.category.name
      : capitalize(GameDayModel.OrderPriority[order.priority]);

  return {
    id: order.id,
    orderNumber: order.orderNumber,
    manager: getManagerName(order),
    account: order.accountInfo.name,
    linkType: getLinkType(order.accountInfo.priority),
    priority,
    orderType: order.orderType && order.orderType.code,
    series: order.series && order.series.code,
    maturityDate:
      order.maturity && order.maturity.maturityDate
        ? order.maturity.maturityDate.toDate()
        : null,
    maturity:
      order.maturity &&
      order.maturity.maturityDate &&
      order.maturity.maturityDate.format(maturityFormat),
    amountFormatted: amountFormat.format(order.amount / 1000),
    amount: order.amount / 1000,
    comments: order.comments
  };
}

function getLinkType(priority: GameDayModel.AccountPriority): string {
  return priority === GameDayModel.AccountPriority.regular
    ? ACCOUNT_TYPE
    : NON_ACCOUNT_TYPE;
}

export {
  getViewOrder,
  getLinkType,
  maturityFormat,
  ViewOrder,
  ACCOUNT_TYPE,
  NON_ACCOUNT_TYPE,
  capitalize
};
